import { CellContentType } from './../../../../shared/components/table/models/cellContent.model';
import { TableHeaders } from './../../../../shared/components/table/models/tableHeaders.model';

export const ConfigurationPoolTableHeaders: TableHeaders[] = [
  {
    key: 'name',
    label: 'POOL',
    content: {
      maxLength: 36,
      type: CellContentType.Text
    }
  },
  {
    key: 'id',
    label: 'ABBR',
    content: {
      maxLength: 5,
      type: CellContentType.Text
    }
    // ,
    // disabledCondition: ({ newItem }) => !newItem
  },
  {
    key: 'save',
    label: '',
    content: {
      type: CellContentType.Button,
      label: 'Save'
    },
    disabledCondition: ({ name, id }) => !name?.length || !id?.length
  },
  {
    key: 'active',
    label: ' ',
    content: {
      type: CellContentType.Switcher
    }
  }
];
